import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const GoogleCalendarCallback = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("loading");
  const [message, setMessage] = useState("Traitement de l'autorisation...");

  useEffect(() => {
    const handleCallback = async () => {
      const code = searchParams.get("code");
      const error = searchParams.get("error");

      if (error) {
        setStatus("error");
        setMessage("L'autorisation a été refusée ou a échoué.");
        return;
      }

      if (!code) {
        setStatus("error");
        setMessage("Code d'autorisation manquant.");
        return;
      }

      try {
        const response = await axios.get(`${API}/integrations/calendar/callback?code=${code}`);
        setStatus("success");
        setMessage(response.data.message || "Google Calendar connecté avec succès !");
        
        // Rediriger vers les intégrations après 3 secondes
        setTimeout(() => {
          window.location.href = "/integrations";
        }, 3000);

      } catch (error) {
        setStatus("error");
        setMessage(
          error.response?.data?.detail || 
          "Erreur lors de la connexion à Google Calendar"
        );
      }
    };

    handleCallback();
  }, [searchParams]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="max-w-md mx-auto">
        <div className="card">
          <div className="card-body text-center">
            {status === "loading" && (
              <>
                <div className="loading-spinner mx-auto mb-4"></div>
                <h2 className="text-xl font-semibold text-gray-900 mb-2">
                  Connexion à Google Calendar
                </h2>
                <p className="text-gray-600">{message}</p>
              </>
            )}

            {status === "success" && (
              <>
                <div className="text-6xl mb-4">✅</div>
                <h2 className="text-xl font-semibold text-green-600 mb-2">
                  Connexion réussie !
                </h2>
                <p className="text-gray-600 mb-4">{message}</p>
                <p className="text-sm text-gray-500">
                  Redirection vers les intégrations dans 3 secondes...
                </p>
              </>
            )}

            {status === "error" && (
              <>
                <div className="text-6xl mb-4">❌</div>
                <h2 className="text-xl font-semibold text-red-600 mb-2">
                  Erreur de connexion
                </h2>
                <p className="text-gray-600 mb-4">{message}</p>
                <a
                  href="/integrations"
                  className="btn-primary"
                >
                  Retour aux intégrations
                </a>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GoogleCalendarCallback;